import { getWebAppBffApiClient } from './web-app-bff-api-client';
export * from '../kubb-api-client';

export const axiosClient = getWebAppBffApiClient({ path: 'nlp-integration' });

export default axiosClient;
